import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {StarIcon, ChevronDownIcon, ChevronRightIcon} from 'shells/icon';
import {Divider} from 'shells/layout/divider';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';

import {IntercomLaunchButton} from '../../../intercom/intercom-launch-button';
import {getImageFromCsmType} from '../../../sidebar/meet-your-csm/helpers';
import {useGetCsmInfo} from '../../../sidebar/meet-your-csm/use-get-csm-info';

import styles from './meet-your-csm.module.css';

export function MeetYourCsm() {
    const {csmInfo} = useGetCsmInfo();
    const [isExpanded, setIsExpanded] = React.useState(window.innerHeight >= 650);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerHeight < 650 && isExpanded) {
                setIsExpanded(false);
            }
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [isExpanded]);

    if (!NutClientConfig.hasNutshellAdvisorFF && !csmInfo) {
        return null;
    }

    if (!csmInfo) {
        return (
            <div className='pad-16 border-bottom'>
                <div className={styles.intro}>
                    You are on a Nutshell Advisor plan, and your advisor will be assigned shortly.
                    <IntercomLaunchButton
                        size='big'
                        variant='text-primary'
                        data-type={undefined}
                        noPadding={true}
                    >
                        <span>Contact us with questions</span>
                    </IntercomLaunchButton>
                </div>
            </div>
        );
    }

    const {csmType, firstName, calendlyLink, emailAddress, funFact} = csmInfo;
    const source = getImageFromCsmType(csmType);

    return (
        <>
            <div className='pad-16'>
                <div
                    className='pointer-cursor flex align-center justify-sb'
                    style={{marginBottom: isExpanded ? 12 : 0}}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className='flex align-center'>
                        <img src={source} alt={firstName} className={styles.image} />
                        <div className={styles.intro}>Meet {firstName}, your Nutshell Advisor</div>
                    </div>
                    {isExpanded ? (
                        // @ts-expect-error
                        <ChevronDownIcon size={12} color={colors.grey} />
                    ) : (
                        // @ts-expect-error
                        <ChevronRightIcon size={12} color={colors.grey} />
                    )}
                </div>
                <div className={isExpanded ? styles['content--expanded'] : styles.content}>
                    <StackLegacy spacing={12}>
                        <div>
                            {firstName} can help you set up your account, answer any questions, and
                            get Nutshell working for you in no time.
                        </div>
                        <StackLegacy spacing={6}>
                            <Link
                                variant='button-primary'
                                size='small'
                                isFullWidth={true}
                                href={calendlyLink}
                                newTab={true}
                            >
                                Schedule a call
                            </Link>
                            <Link
                                variant='button-secondary'
                                size='small'
                                isFullWidth={true}
                                href={`mailto:${emailAddress}`}
                                newTab={true}
                            >
                                Send an email
                            </Link>
                        </StackLegacy>
                        <div className={styles.fact}>
                            <div className='flex align-center mb-2'>
                                <StarIcon size={12} className='pr-4 color-primary' />
                                <div className={styles.fun}>Fun fact</div>
                            </div>
                            {funFact}
                        </div>
                    </StackLegacy>
                </div>
            </div>
            <Divider variant='line--horizontal' />
        </>
    );
}
